import { Button } from '@progress/kendo-react-buttons';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { TextBox } from '@progress/kendo-react-inputs';
import { useCallback, useEffect, useState } from 'react';
import { MessageType } from '../../services/actor-messages';
import { useEvent } from '../contexts/event-bus';
import { useFlightWorker } from '../hooks/use-flight-worker';

export function ScratchpadWindow() {
    const [flightId, setFlightId] = useState<number | null>(null);
    const [scratchpad, setScratchpad] = useState('');
    const worker = useFlightWorker();

    useEvent(
        'show-scratchpad-window',
        useCallback((e) => setFlightId(e.flightId), [])
    );

    useEffect(() => {
        if (flightId === null) {
            return;
        }

        worker.actor.sendAsync({ type: MessageType.getFlightScratchpad, data: { flightId } }).then((e) => setScratchpad(e.scratchpad));
    }, [flightId, worker]);

    if (flightId === null) {
        return null;
    }

    const handleSave = () => {
        worker.actor.sendAsync({ type: MessageType.setFlightScratchpad, data: { flightId, scratchpad } });
        setFlightId(null);
        setScratchpad('');
    };

    return (
        <Dialog title={'Edit scratchpad'} minWidth={350} onClose={() => setFlightId(null)}>
            <div>
                <TextBox
                    value={scratchpad}
                    onChange={(e) => setScratchpad(e.value as string)}
                    maxLength={15}
                    placeholder="Scratch pad text"
                />
            </div>
            <div className="secondary-text d-flex justify-content-end pt-2">{scratchpad.length}/15</div>
            <DialogActionsBar>
                <Button themeColor="primary" onClick={handleSave}>
                    Save
                </Button>
                <Button onClick={() => setFlightId(null)}>Cancel</Button>
            </DialogActionsBar>
        </Dialog>
    );
}
